import BREAKPOINTS from './breakpoints';
export const SPACINGS = [0, 4, 8, 16, 24, 32, 40, 48, 72];
const getSpacingClassesPerBreakpoint = (property, breakpoint) => {
    const windowWidth = breakpoint.replace('px', '');
    return SPACINGS.reduce((classes, spacing) => (Object.assign(Object.assign({}, classes), { [`${windowWidth}_${spacing}`]: {
            '@media': {
                [`screen and (min-width: ${breakpoint})`]: {
                    [property]: `${spacing}px`,
                },
            },
        } })), {});
};
export const getResponsiveSpacingClassesFor = (property) => (Object.assign({}, Object.values(BREAKPOINTS).reduce((acc, breakpoint) => (Object.assign(Object.assign({}, acc), getSpacingClassesPerBreakpoint(property, breakpoint))), {})));
const argumentContainsBasePreference = (argument) => Object.prototype.hasOwnProperty.call(argument, '0px');
export const getSpacingClasses = (argument, baseVariants, responsiveVariants) => {
    if (typeof argument === 'number') {
        return baseVariants[argument];
    }
    const responsiveClasses = [];
    if (!argumentContainsBasePreference(argument)) {
        responsiveClasses.push(responsiveVariants[`0_16`]);
    }
    return Object.entries(argument).reduce((rules, rule) => {
        const [breakpoint, spacing] = rule;
        const windowWidth = breakpoint.replace('px', '');
        return [...rules, responsiveVariants[`${windowWidth}_${spacing}`]];
    }, responsiveClasses);
};
